import { useAuth } from "@/hooks/use-auth";
import { Redirect, Route, useLocation } from "wouter";
import LoadingSpinner from "@/components/ui/loading-spinner";
import TranslatedLoadingSpinner from "@/components/common/TranslatedLoadingSpinner";

export function ProtectedRoute({
  path,
  component: Component,
  adminOnly = false,
}: {
  path: string;
  component: React.ComponentType<any>;
  adminOnly?: boolean;
}) {
  const { user, isLoading } = useAuth();
  const [location] = useLocation();

  if (isLoading) {
    return (
      <Route path={path}>
        <TranslatedLoadingSpinner fullPage textKey="profile.loading.authentication" />
      </Route>
    );
  }

  if (!user) {
    return (
      <Route path={path}>
        <Redirect to={`/auth?redirect=${encodeURIComponent(location)}`} />
      </Route>
    );
  }

  if (adminOnly && !user.isAdmin) {
    return (
      <Route path={path}>
        <Redirect to="/" />
      </Route>
    );
  }

  return <Route path={path} component={Component} />;
}
